














































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Toast, Popup, Picker, Icon, Checkbox } from 'vant';
import SyEditor from '@/components/SyEditor.vue';
import Uploader from '@/components/Uploader.vue';
import { contribute } from '../api';

Vue.use(Toast).use(Popup).use(Picker).use(Icon).use(Checkbox);

function genClassNumber(classNumberLength: number) {
  const arr: any[] = [];
  const base = Array.from(new Array(classNumberLength));

  base.forEach((item, index) => {
    const classNumber = index + 1;
    const el =
      classNumber < 10 ? `0${classNumber.toString()}` : classNumber.toString();
    arr.push(el);
  });
  return arr;
}

@Component({
  components: {
    SyEditor,
    Uploader,
  },
})
export default class Contribute extends Vue {
  grade = '请选择年级';
  classNum = '请选择班级';
  area = '请选择区域';
  areaId = -1;
  author = '';
  teacherName = '';
  title = '';
  showPicker = false;

  currentPickerDataKey = 'grade';
  showGradeAndClassNum = true;

  get pickerData() {
    const allData: any = {
      grade: [
        '一年级',
        '二年级',
        '三年级',
        '四年级',
        '五年级',
        '六年级',
        '初一',
        '初二',
        '初三',
        '高一',
        '高二',
        '高三',
      ],
      classNum: genClassNumber(60),
      area: [
        '重庆大学城第一中学',
        '重庆市第一实验中学',
        '重庆师范大学附属中学',
        '大学城人民小学',
        '富力南开小学',
        '大学城树人小学',
        '南开景阳小学',
        '树人思贤小学',
        '重庆师范大学附属小学',
        '虎溪辖区居民',
      ],
    };
    return allData[this.currentPickerDataKey];
  }

  @Watch('area')
  onAreaChange(newval: string, oldval: string) {
    if (newval === '虎溪辖区居民') {
      this.showGradeAndClassNum = false;
      this.grade = '';
      this.classNum = '';
    } else {
      this.showGradeAndClassNum = true;
      this.grade = '请选择年级';
      this.classNum = '请选择班级';
    }
  }

  checkForm() {
    if (this.area === '请选择区域') {
      Toast('请选择区域');
      return false;
    } else if (!this.title) {
      Toast('请填写作文标题');
      return false;
    } else if (!this.author) {
      Toast('请填写作者姓名');
      return false;
    } else if (this.grade === '请选择年级' && this.showGradeAndClassNum) {
      Toast('请填写年级');
      return false;
    } else if (this.classNum === '请选择班级' && this.showGradeAndClassNum) {
      Toast('请填写班级');
      return false;
    } else if (!(this.$refs.editor as SyEditor).content) {
      Toast('请填作文正文');
      return false;
    } else {
      return true;
    }
  }

  onBlur() {
    // const u = navigator.userAgent;
    // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // if (isiOS) {
    //   window.scrollTo(0, 0);
    // }
  }
  onConfirm(val: string, index: number) {
    this.togglePicker();
    if (this.currentPickerDataKey === 'grade') {
      this.grade = val;
    } else if (this.currentPickerDataKey === 'classNum') {
      this.classNum = val;
    } else {
      this.area = val;
      this.areaId = index + 1;
    }
  }
  onCancel() {
    this.togglePicker();
  }
  togglePicker(stateKey?: string) {
    this.showPicker = !this.showPicker;
    if (stateKey) {
      this.currentPickerDataKey = stateKey;
    }
  }

  async onSubmit() {
    if (!this.checkForm()) {
      return;
    }
    const retSave: any = await contribute({
      title: this.title,
      user: this.author,
      teacher: this.teacherName,
      area_id: this.areaId,
      area_text: this.area,
      grade: this.grade,
      class: this.classNum,
      content: (this.$refs.editor as SyEditor).content,
    });
    Toast(retSave.msg);
    if (retSave.code === 200) {
      this.reset();
    }
  }
  reset() {
    this.title = '';
    this.author = '';
    this.teacherName = '';
    this.area = '请选择区域';
    this.grade = '请选择年级';
    this.classNum = '请选择班级';
    (this.$refs.editor as SyEditor).clear();
  }
}
